import { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { axiosIns } from "../../../utils";
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

import {
    Card,
    CardBody,
    Col,
    Container, Row, Input, Label,
    FormFeedback,
    Form,
    Spinner
} from "reactstrap";

// Redux


import { Link, useHistory, useParams } from "react-router-dom";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// Import React FilePond
import { registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import { toast } from "react-toastify";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const MetiersUpdate=(props)=>{
  document.title = props.t("Modifier métiers");
  const history = useHistory();
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const [selectedFiles, setselectedFiles] = useState([]);
  const [selectedGroup, setselectedGroup] = useState(null);
  const [selectedStatus, setselectedStatus] = useState(null);
  const [selectedVisibility, setselectedVisibility] = useState(null);

  const metiersId = useParams('id');
  const [selectMetier, setSelectMetier] = useState({})
  useEffect(() => {
      const fetchData = async () => {
        try {
          const data  = await axiosIns.get(`/metiers/${metiersId.id}/`);
          setSelectMetier(data?.data || data || {})
        } catch (err) {
          console.error(err);
        }
      };
      fetchData();

    }, [metiersId]);

  const [metierList,setMetierList]=useState([]);
  useEffect(() => {
      const fetchData = async () => {
        try {
          const data  = await axiosIns.get(`/metiers/`);
          setMetierList(data?.data || data || [])
        } catch (err) {
          console.error(err);
        }
      };
      fetchData();

    }, []);


  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      "designation_metier":selectMetier.label || selectMetier.designation_metier
    },

    validationSchema: Yup.object().shape({
      designation_metier: Yup.string().required(props.t("Entrer un nom")),
    }),

    // `async` so Formik tracks the request through `isSubmitting`: the handler
    // used to fire the PATCH without awaiting it, so the submit button never
    // reflected that anything was happening and could be pressed again.
    onSubmit: async (values) => {
      const newCategory = {
        id: selectMetier.id,
        label: values.designation_metier,
      };

      try {
        await axiosIns.patch(`/metiers/${metiersId.id}/`, newCategory);
        toast.success(props.t("Metier bien modifié"), { autoClose: 3000 });
        validation.resetForm();
        history.push("/jobs");
      } catch (error) {
        // axios rejects on failure rather than resolving falsy, so the previous
        // `else` branch was unreachable and a failed update still redirected.
        toast.error(props.t("Métier non modifié"), { autoClose: 3000 });
      }
    },
  });
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={props.t("Modification de métier")} pageTitle={props.t("Métiers")} />

        <Row>
          <Col lg={12}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();

              }}
              >
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="designation_metier">
                      {props.t("Titre du metier")}
                    </Label>
                    <Input
                      type="text"
                      className="form"
                      name="designation_metier"
                      value={validation.values.designation_metier}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      required
                    />
                    {validation.errors.designation_metier && validation.touched.designation_metier ? (
                      <FormFeedback type="invalid">{validation.errors.designation_metier}</FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>

              <div className="text-end mb-3">
              <Link to="/jobs" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                <button
                  type="submit"
                  className="btn btn-warning w-sm"
                  disabled={validation.isSubmitting}
                >
                  {validation.isSubmitting && (
                    <Spinner size="sm" className="me-2" />
                  )}
                  {props.t("Modifier")}
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

MetiersUpdate.propTypes={
  location:PropTypes.object,
  t:PropTypes.any
}
export default withRouter(withTranslation()(MetiersUpdate));
